<!-- 
程式：fullPreview.vue
功能：活動內容-預覽
作者：i9400540 施義濃
完成：2020-02-15
-->
<template>
  <div class="content_font">
    <div class="l-container">
      <div class="o-menuMask"></div>
      <div v-html="htmlContent"></div>
      <a href="javascript:;" class="o-gotoTop" data-id="gotop"></a>
    </div>
    <div id="CI_LINK_MSG" class="mfp-hide" style="width: 30%; margin: 0 auto">
      <div class="c-popup__head" data-alert="title">提醒您</div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content">您將離開本頁面，並前往國泰人壽官網首頁。</div>
        <div class="c-popup__actions">
          <a
            href="javascript:;"
            class="o-btn o-btn--normal"
            style="margin-right: 5px"
            data-mfp-close
            >取消</a
          >
          <a
            @click="gotoCathayLife"
            class="o-btn o-btn--normal o-btn--primary"
            style="margin-left: 5px"
            >立即前往</a
          >
        </div>
      </div>
    </div>
    <!-- 回國泰人壽官網首頁 -->
    <div id="CI_LINK_MSG2" class="mfp-hide" style="width: 30%; margin: 0 auto">
      <div class="c-popup__head" data-alert="title">提醒</div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content" style="text-align: left">
          很抱歉！本活動限國泰人壽在職內外勤員工(除業專、服中客服專員)，您將離開本頁面，並前往網路投保網站。
        </div>
        <div class="c-popup__actions">
          <a @click="gotoCathayLife" class="o-btn o-btn--normal o-btn--primary"
            >立即前往</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DTODAV01 from "@/service/DTODAV01.js";
import DTODAV02 from "@/service/DTODAV02.js";

import DTODAVZ1 from "@/service/DTODAVZ1.js";
import $ from "jquery";
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";

export default {
  name: "ODAVF001",
  data() {
    return {
      actInfo: {
        act_id: "",
        login_e: "N",
        login_m: "N",
        page_id: "",
        home_page: "",
      },
      htmlContent: "",
      isLogin: false,
      msg: "請先登入",
      //國泰人壽首頁
      VUE_APP_LINK_CATHAYLIFE: process.env.VUE_APP_LINK_CATHAYLIFE,
      //網路投保首頁
      VUE_APP_LINK_WTHOME: process.env.VUE_APP_LINK_WTHOME,
      //會員專區
      VUE_APP_LINK_MEMBER: process.env.VUE_APP_LINK_MEMBER,
      //聯絡我們
      VUE_APP_LINK_CONNECTION: process.env.VUE_APP_LINK_CONNECTION,
      //顧客資料保密措施
      VUE_APP_LINK_SECRET: process.env.VUE_APP_LINK_SECRET,
    };
  },
  created() {
    import("@/assets/webpage/js/vendor/modernizr-3_5_0-min.js").then((m) => {});

    import("@/assets/webpage/js/vendor/picturefill/picturefill-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/picturefill/pf-mutation-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/matchMedia/matchMedia-min.js").then(
      (m) => {}
    );

    import(
      "@/assets/webpage/js/vendor/jquery-fancyform/jquery-fancyform-min.js"
    ).then((m) => {});
    import("@/assets/webpage/js/vendor/slick/slick.js").then((m) => {});

    //bind 錨點的方法
    window.scrollAnchor = this.scrollAnchor.bind(this);
  },
  mounted() {
    this.$nextTick(() => {
      this.initFun();
    });
    this.$cathayAxios.post(DTODAVZ1.checkLogin, {}).then((resp) => {
      if (resp.returnCode == 0) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
        window.location =
          window.location.protocol +
          "//" +
          // 導去網投首頁
          window.location.host +
          "/ODAV/#/ODAVF101";
      }
    });
    let actionId = this.$route.query.actionId || "";
    if (actionId) {
      this.$cathayAxios
        .post(DTODAV01.doQueryActionByPreview, { act_id: actionId })
        .then((resp) => {
          if (resp.returnCode == 0) {
            this.actInfo = resp.data || {};
            this.doQuery(actionId);
          } else {
            this.htmlContent = "";
          }
        });
    } else {
      this.gotoCathayLife();
    }
  },
  methods: {
    // 取得編輯資料
    doQuery(act_id) {
      let cVue = this;
      let tempContent = "";
      cVue.$cathayAxios
        .post(DTODAV02.getActContent, {
          act_id: act_id,
        })
        .then((resp) => {
          if (resp.returnCode == 0) {
            let data = resp.data || [];
            for (let i = 0; i < data.length; i++) {
              tempContent =
                tempContent + decodeURIComponent(data[i].block_content);
            }
            if (tempContent) {
              this.htmlContent = tempContent;
            }
          } else {
            this.htmlContent = "";
          }
        });
    },
    // 前往國泰人壽
    gotoCathayLife(temp) {
      if (!temp || !temp.home_page) {
        window.location.href = this.VUE_APP_LINK_CATHAYLIFE;
      } else {
        window.location.href = temp.home_page;
      }
    },
    // 錨點
    scrollAnchor(id) {
      let animationTime = {
        type: Number,
        default: 300,
      };
      let item = $("#" + id);
      if (!item || item.length == 0) {
        return;
      }
      let move = item.offset().top - 65;
      $("html").animate({ scrollTop: move }, this.animationTime);
    },
    // 回國泰人壽網頁(目前無使用)
    // showAlert(temp) {
    //   $.fancybox.open({
    //     src: "#CI_LINK_MSG2",
    //     modal: true,
    //     beforeLoad: function () {
    //       $("#CI_LINK_MSG_Link1").on("click", function (e) {
    //         e.preventDefault();
    //         cVue.gotoCathayLife(temp);
    //       });
    //     },
    //   });
    //   let cVue = this;
    //   setTimeout(function () {
    //     cVue.gotoCathayLife(temp);
    //   }, 3000);
    // },
    initFun() {
      $("#CI_Link").on("click", function (e) {
        e.preventDefault();
        $.magnificPopup.open({
          items: {
            src: "#CI_LINK_MSG",
            type: "inline",
          },
          callbacks: {
            open: function () {
              $("#CI_LINK_MSG_Link1").on("click", function (e) {
                e.preventDefault();
                window.location = VUE_APP_LINK_CATHAYLIFE;
              });

              $("#CI_LINK_MSG .o-btn--normal[data-mfp-close]").on(
                "click",
                function (e) {
                  e.preventDefault();
                  $.magnificPopup.close();
                }
              );
            },
          },
        });
      });
    },
  },
};
</script>
<style
  src="@/assets/webpage/css/jquery_fancyform/jquery_fancyform_min.css"
></style>
<style src="@/assets/webpage/js/vendor/slick/slick-min.css"></style>
<style src="@/assets/webpage/js/vendor/slick/slick-theme-min.css"></style>
<style
  src="@/assets/webpage/js/vendor/bootstrap-datepicker/bootstrap-datepicker.standalone.min.css"
></style>
<style src="@/assets/webpage/css/common/normalize-min.css"></style>
<style src="@/assets/webpage/css/common/animate-min.css"></style>
<style src="@/assets/webpage/css/common/layout-min.css"></style>
<style src="@/assets/webpage/css/form-min.css"></style>
<style src="@/assets/webpage/css/product-min.css"></style>
<style src="@/assets/webpage/css/index.css"></style>
<style src="@/assets/webpage/css/common/main.css"></style>
<style src="@/assets/third-party/css/font-awesome.min.css"></style>

<style>
.c-popup__content {
  background-color: white;
}
.user2 {
  position: relative;
  display: inline-block;
}
.user2 input {
  text-indent: 20px;
}
.fb-share-button {
  background: url("~@/assets/webpage/images/fb_icon.jpg") center center
    no-repeat;
  background-size: cover;
  width: 39px;
  height: 39px;
}
.line-share-button {
  background: url("~@/assets/webpage/images/line_icon.jpg") center center
    no-repeat;
  background-size: cover;
  width: 39px;
  height: 39px;
}
</style>
